import {
  saveDataToLocalStorage,
  triggerUserReauthenticate,
} from "@store/customActions";
import { getFromLocalStorage } from "@utils/localStorage";
import { isZoomApp } from "@utils/helpers";
import { JWT_TOKEN_NAME, APP_TYPE } from "@constants";
import { DEMO_GUEST_TOKEN_KEY } from "@constants/guestAgenda";

const AppType = isZoomApp ? APP_TYPE.ZoomApp : APP_TYPE.WebApp;

export const addTokenToHeader = (headers) => {
  const baseHeaders = headers || {};

  const token = getFromLocalStorage(JWT_TOKEN_NAME);
  if (token) {
    baseHeaders["authorization"] = `Bearer ${token}`;
  }
  baseHeaders["apptype"] = AppType;

  // Phase 2 (guest demo): when an anonymous visitor is running the demo, attach
  // their guest token so DemoGuestAccessMW can authorize demo-runtime calls.
  // Only send it for unauthenticated requests: DemoGuestAccessMW prioritizes the
  // guest token over the JWT, so a lingering token would make an authed user be
  // treated as the synthetic guest and fail ownership checks ("not the creator").
  const demoGuestToken = getFromLocalStorage(DEMO_GUEST_TOKEN_KEY);
  if (demoGuestToken && !token) {
    baseHeaders["x-guest-token"] = demoGuestToken;
  }

  return baseHeaders;
};

export const transformResponse = (response) => response?.content || {};

//TODO: add tests for this function
export const refreshAccessToken = async (api) => {
  // Import authApi dynamically to avoid circular dependency
  const { authApi } = await import("@store/api/auth");
  const response = await api.dispatch(
    authApi.endpoints.refreshToken.initiate()
  );
  const accessToken = response?.data?.accessToken;

  if (accessToken) {
    api.dispatch(
      saveDataToLocalStorage({
        key: JWT_TOKEN_NAME,
        value: accessToken,
      })
    );
  }

  return accessToken;
};

//TODO: add tests for this function
export const refreshTokenAndRetryRequest = async (
  fetchBaseQuery,
  api,
  args,
  headers
) => {
  const accessToken = await refreshAccessToken(api);

  if (accessToken) {
    const updatedHeaders = {
      ...headers,
      authorization: `Bearer ${accessToken}`,
    };
    const refreshedArgs = {
      ...args,
      headers: updatedHeaders,
      credentials: "include",
    };
    return await fetchBaseQuery(refreshedArgs, api, {});
  }

  api.dispatch(triggerUserReauthenticate());
};
